module.exports = __webpack_public_path__ + "media/images/newsletter/newsletter-social-21748c30f9e96e5816d2fcac46a0b680.png";